import { Link } from "react-router-dom";

import { PageHeader } from "../components/layout/PageHeader";

/** Shown for any address the console does not know. */
export function NotFoundPage(): JSX.Element {
  return (
    <>
      <PageHeader title="Nothing here" subtitle="This address does not exist." />
      <div className="state-block">
        <Link to="/" className="btn">
          Back to GPUs
        </Link>
      </div>
    </>
  );
}
